import React from 'react'
import ServiceTypeSurvey from './ServiceType'
import SystemTypeSurvey from './SystemType'
import StatusSurvey from './Status'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import { FileText } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'


function SurveyReportSettings() {
    return(
        <>
       
                     <HeadingWithIcon icon={FileText} title="Survey Report" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <ServiceTypeSurvey/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <SystemTypeSurvey/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusSurvey/>
         </div>
        
       
         </div>
         </>
    )
}

export default SurveyReportSettings